import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';

export default class PortalDatePicker extends Component {

    render() {

        return(
            <DatePicker 
                floatingLabelText={this.props.floatingLabelText}
                dialogContainerStyle={{
                    boxShadow: '0 4px 3px 0 rgba(0,0,0,0.2)'
                }}
                className='portal-date-picker' 
                {...this.props} 
                hideCalendarDate={false}
                locale={window.navigator.language} />
        );
    }    
}


// WEBPACK FOOTER //
// ./src/components/portal/portalDatePicker.jsx